import { allPass, includes } from 'ramda';

import { isSingleton } from '../../util';
import { DataTransferType } from '../models';

type OnlyFiles = (types: readonly string[]) => boolean;

export const onlyFiles: OnlyFiles = allPass([
  isSingleton,
  includes(DataTransferType.Files)
]);
